
import request from '../utils/request'
const {swSewagePath} = window.globalConfig;
export default class StationApi {
    /**
     * 获取所有的站点信息
     * @param params
     * @returns {*|Promise<*>}
     */
    static selectAllStation = (params) => {
        return request.post(`/sw-sewage/api/0/station/selectAll`, params)
    }

    /**
     * 获取所有运营中的站点信息
     * @param params
     * @returns {*|Promise<*>}
     */
    static findOperateStations = (params) => {
        return request.post(`/sw-sewage/api/0/station/findOperateStations`, params)
    }

     /**
     * 批量导出
     * @param params
     * @returns {*|Promise<*>}
     */
    static batchExport = (params) => {
        return request.post('/sw-sewage/api/0/station/exportByQuery', params,{
            responseType: 'blob'
        })
    }

     /**
     * 新建设备
     * @param params
     * @returns {*|Promise<*>}
     */
    static createStation = (params) => {
        return request.post('/sw-sewage/api/0/station/create', params)
    }

     /**
     * 删除
     * @param params
     * @returns {*|Promise<*>}
     */
    static deleteStationByIdDevice = (params) => {
        return request.post('/sw-sewage/api/0/station/deleteById', params)
    }

     /**
     * 通过ids导出站点信息
     * @param params
     * @returns {*|Promise<*>}
     */
    static exportByIds = (params) => {
        return request.post('/sw-sewage/api/0/station/exportByIds', params)
    }

     /**
     * 通过Id查询设备VO
     * @param params
     * @returns {*|Promise<*>}
     */
    static getStationById = (params) => {
        return request.post('/sw-sewage/api/0/station/getById', params)
    }

     /**
     * 获取列表
     * @param params
     * @returns {*|Promise<*>}
     */
    static selectByPage = (params) => {
        return request.post('/sw-sewage/api/0/station/selectByPage', params)
    }

     /**
     * 修改设备
     * @param params
     * @returns {*|Promise<*>}
     */
    static updateStation = (params) => {
        return request.post('/sw-sewage/api/0/station/update', params)
    }

    /**
     * 根据厂站id查询设备
     * 
     */

    //  static getDeviceByStationId = (params) => {
    //     return request.appid(`/sw-sewage/api/device/getDeviceByStationId?stationId=${params.stationId}`)
    // }

    /**
     * 根据厂站id查询设备
     * 
     */

     static getDeviceByStationId = (params) => {
        return request.post(`/sw-patrol/api/deviceRelevancy/getDeviceRelevancy`,{id: params.stationId})
    }

     /**
     * 分区查询所有站点信息
     * @param params
     * @returns {*|Promise<*>}
     */
    static findStationsWithArea = (params) => {
        return request.post('/sw-sewage/api/0/station/findStationsWithArea', params)
    }

    static listByPageStation = (params) => {
        return request.post(`/${swSewagePath}/api/station/pageList`, params)
    }


    static statistics = (params) => {
        return request.post(`/${swSewagePath}/api/station/statistics`, params)
    }

    static update = (params) => {
        return request.post(`/${swSewagePath}/api/station/update`, params)
    }

    static updateProcessUnit = (params) => {
        return request.post(`/${swSewagePath}/api/device/updateProcessUnit`, params)
    }

















}
